import { Theme } from '@mui/material/styles';

import { navigationHeight } from './utils/constants';

export const appContentPadding = 3;

/**
 * Viewport minus nav and the vertical inset of `#appContent` padding.
 * `spacing(2 * n)` equals top + bottom padding for uniform `p: n` (MUI default spacing is linear).
 */
export const contentHeight100Percent = (theme: Theme) =>
  `calc(100vh - ${navigationHeight}px - ${theme.spacing(2 * appContentPadding)})`;

export const appContentSx = () => ({
  p: appContentPadding,
  maxWidth: '100%',
  minHeight: `calc(100vh - ${navigationHeight}px)`,
});

export const layoutContainerSx = {
  display: 'flex',
  height: contentHeight100Percent,
};
